module.exports = __webpack_public_path__ + "static/media/DSCF0007.eb7c3ec4.jpg";